function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Fasting from 'svg/fasting.svg';
import PreMeal from 'svg/pre-meal.svg';
import PostMeal from 'svg/post-meal.svg';
import NoFlag from 'svg/no-flag.svg';
import Total from 'svg/total.svg';
var _React_PureComponent;
class ReadingFlagIcon extends (_React_PureComponent = React.PureComponent) {
    getIcon(flag) {
        switch(flag){
            case 'All':
                return Total;
            case 'Fasting':
                return Fasting;
            case 'PreMeal':
                return PreMeal;
            case 'PostMeal':
                return PostMeal;
            case 'None':
                return NoFlag;
            default:
                return null;
        }
    }
    render() {
        const { flag, className, width, height } = this.props;
        const Icon = this.getIcon(flag);
        return Icon && /*#__PURE__*/ _jsx(Icon, {
            width: width,
            height: height,
            className: className
        });
    }
}
_define_property(ReadingFlagIcon, "propTypes", {
    flag: PropTypes.oneOf([
        'All',
        'Fasting',
        'PreMeal',
        'PostMeal',
        'Logbook',
        'None'
    ]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    width: PropTypes.string,
    height: PropTypes.string
});
export default ReadingFlagIcon;
